import { Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from '@mui/material'
import { ImageCrop, useCropImage } from './ImageCrop'
import { theme } from '~/lib/theme'

export const ImageCropDialog = (props: { image: Blob; onSave(image: Blob): void; onCancel(): void }) => {
  const control = useCropImage(props.image)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog open fullScreen={isMobile} onClose={props.onCancel}>
      <DialogTitle>画像を切り取る</DialogTitle>
      <DialogContent
        sx={{
          mt: { xs: 3, sm: 0 },
          width: { xs: '100%', sm: 500, md: 600 },
        }}
      >
        <ImageCrop {...control.props} />
      </DialogContent>
      <DialogActions>
        {/* TODO: MarketingButtonがdisabledに対応したら置き換える */}
        <Button
          variant="contained"
          onClick={async () => props.onSave(await control.crop())}
          disabled={!control.cropped}
        >
          切り取る
        </Button>
        <Button variant="outlined" onClick={props.onCancel}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  )
}
